import { memo } from "react";

/**
 * A multilateral well: one bore descending from surface, turning horizontal,
 * and branching into three laterals ("drain legs").
 *
 * Drawn rather than borrowed. The nearest stock glyph is Material's AccountTree,
 * which reads as a folder/org hierarchy — and this icon sits on the same toolbar
 * as {@link GroupBy}, so two tree-shaped glyphs side by side would invite
 * "does this group the chart?". The wellbore-with-laterals shape is how these
 * wells are drawn throughout the domain, so it says multilateral and nothing else.
 *
 * Strokes, not fills: at 18px the laterals need to stay separable, and a filled
 * outline closes the gaps between them. `currentColor` throughout so the toolbar
 * button's active/inactive states drive it like every other icon here.
 */
function DrainLegs({ size = 24 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round">
      {/* Main bore: down from surface, then the heel turn. */}
      <path d="M4.5 2.5v9.5a3 3 0 0 0 3 3h2" />
      {/* Three laterals fanning off the junction. */}
      <path d="M9.5 15h10" />
      <path d="M9.5 15l9-4.5" />
      <path d="M9.5 15l9 5.5" />
    </svg>
  );
}

export default memo(DrainLegs);
